import * as TYPES from '@/store/types'
import {ReportedLocation} from '@/models/reported_location'

import axios from 'axios'

// this is the current location
export const setCurrentLocation = ({ commit, state }, geolocation) => {
  let lat = geolocation.coords.latitude
  let lng = geolocation.coords.longitude
  console.log('reported geoLocation: ', geolocation)
  // let lookupUrl = `https://maps.googleapis.com/maps/api/geocode/json?key=${process.env.GOOGLE_MAPS_API_KEY}&latlng=${lat},${lng}`
  // console.log('processing', lookupUrl)
  // Optionally the request above could also be done as
  axios.get('/maps/api/geocode/json', {
    baseURL: 'https://maps.googleapis.com',
    params: {
      key: process.env.GOOGLE_MAPS_API_KEY,
      latlng: `${lat},${lng}`
    }
  })
    .then(function (response) {
      console.log('Google GeoCode Response Status', response.status)
      console.log('Google GeoCode Locations: ', response.data.results)
      let currentLocation = new ReportedLocation(response.data.results[0])
      console.log('committing currentLocation: ', currentLocation)
      commit(TYPES.CURRENT_LOCATION, currentLocation)
      commit(TYPES.LOCATION_BY_ID, currentLocation)
    })
    .catch(function (error) {
      console.log('error using google geocode api', error)
    })
}

export const addLocation = ({ commit, state }, place) => {
  console.log('new location input: ', place)
  let newLocation = new ReportedLocation(place)
  commit(TYPES.LOCATION_BY_ID, newLocation)
}



// WEBPACK FOOTER //
// ./src/store/locations/actions.js